'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.administrationDefaultEntitlement', [])

.factory('adminDefaultEntitlementService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/Administration/DefaultEntitlement/API';

    // HttpGet
    service.getDefaultEntitlementsBySystemRoleId = function (systemRoleId) {
        return $http.get(baseUrl + '/GetDefaultEntitlements/' + systemRoleId,
                         {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getDefaultEntitlements = function (systemRoleId, supervisorId) {
        var url = baseUrl + '/GetImpactedEmployees/' + systemRoleId +
            '?supervisorId=' + supervisorId;

        return $http.get(url, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // HttpPost
    service.addDefaultEntitlement = function(systemRoleId, supervisorId) {
        return $http.post(baseUrl + '/AddDefaultEntitlement/',
        {
            systemRoleId: systemRoleId,
            supervisorId: supervisorId
        })
        .then(function (response) {
            return response.data;
        });
    }

    service.removeDefaultEntitlement = function (systemRoleId, supervisorId) {
        return $http.post(baseUrl + '/RemoveDefaultEntitlement/',
        {
            systemRoleId: systemRoleId,
            supervisorId: supervisorId
        })
        .then(function (response) {
            return response.data;
        });
    }

    return service;
}]);
